import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { HeadlineS } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { useToggle } from '@sorare/core/src/hooks/useToggle';

import { DialogContainer as Container } from './Container/index.tsx';

const messages = defineMessages({
  cta: {
    defaultMessage: 'Deposit Cards',
  },
  title: {
    defaultMessage: 'Deposit Cards',
  },
});

const Body = styled.div`
  padding: var(--triple-unit);
`;

export const DepositCard = () => {
  const [open, toggleOpen] = useToggle(false);
  const { up: isTablet } = useScreenSize('tablet');

  return (
    <>
      <Button onClick={toggleOpen} color="quaternary" size="small">
        <FormattedMessage {...messages.cta} />
      </Button>
      {!!open && (
        <Dialog
          open
          onClose={toggleOpen}
          maxWidth="sm"
          fullScreen={!isTablet}
          title={
            <HeadlineS as="h5" className="text-center">
              <FormattedMessage {...messages.title} />
            </HeadlineS>
          }
        >
          <Body>
            <Container closeDialog={toggleOpen} />
          </Body>
        </Dialog>
      )}
    </>
  );
};
